<script lang="ts">
    /**
     * HeroSection - Section 1: 히어로 배너
     *
     * 풀스크린 (100vh), 왼쪽 텍스트 + 오른쪽 앱 목업
     * - 헤드카피 + 서브카피
     * - CTA 버튼 (사전등록 + 더 알아보기)
     * - 하단 배지 (수상/특허/다운로드)
     */

    let isVisible = $state(false);

    $effect(() => {
        setTimeout(() => {
            isVisible = true;
        }, 100);
    });

    function scrollToNext(e: MouseEvent) {
        e.preventDefault();
        const el = document.querySelector('#differentiation');
        if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
        }
    }

    // TODO: 사전등록 활성화 시 복원
    // function scrollToPreRegister(e: MouseEvent) {
    //     e.preventDefault();
    //     const el = document.querySelector('#pre-register');
    //     if (el) el.scrollIntoView({ behavior: 'smooth' });
    // }
</script>

<section class="hero">
    <div class="hero-inner" class:visible={isVisible}>
        <!-- Left: Text Content -->
        <div class="hero-text">
            <h1 class="hero-title">
                혼자 걷는 걸음,<br />
                함께하면 모험이 된다
            </h1>
            <p class="hero-subtitle">
                근처 친구와 함께 건강 챌린지!<br />
                AI가 이끌어주는 게이미피케이션 헬스케어 플랫폼
            </p>
            <div class="hero-store-badges">
                <a
                    href="https://play.google.com/store/apps/details?id=com.bjf.jadeye"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="hero-badge-link"
                    aria-label="Google Play에서 다운로드 (새 창에서 열림)"
                >
                    <img src="/images/google-play-badge-ko.svg" alt="Google Play에서 다운로드" class="hero-badge" />
                </a>
                <a
                    href="https://apps.apple.com/kr/app/%EC%A0%9C%EC%9D%B4%EB%93%9C%EC%95%84%EC%9D%B4/id6759511149"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="hero-badge-link"
                    aria-label="App Store에서 다운로드 (새 창에서 열림)"
                >
                    <img src="/images/app-store-badge-ko.svg" alt="App Store에서 다운로드" class="hero-badge appstore" />
                </a>
            </div>
            <div class="hero-secondary-row">
                <a href="#differentiation" class="hero-cta-secondary" onclick={scrollToNext}>
                    <span>더 알아보기</span>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M12 5v14" /><path d="m19 12-7 7-7-7" />
                    </svg>
                </a>
            </div>
        </div>

        <!-- Right: App Mockup -->
        <div class="hero-visual">
            <div class="phone-mockup">
                <div class="phone-screen">
                    <!--
                        히어로 = 첫 화면이라 LCP 후보 1순위. webp 로 158KB → 51KB(68% 절감).
                        🚨 함정 9: <picture> 의 <source> 는 "404 폴백"이 아니다. 브라우저가 type 만 보고
                           webp 를 고른 뒤에는 그 URL 이 확정되므로, webp 파일을 지우면 png 로
                           되돌아가지 않고 이미지가 깨진다. png·webp 는 반드시 한 쌍으로 갱신할 것.
                           (webp 재생성: PIL 'WEBP', quality=82, method=6, RGB — 쇼케이스와 같은 설정)
                        loading 은 붙이지 않는다 — 히어로에 lazy 를 걸면 LCP 가 오히려 늦어진다.
                    -->
                    <picture>
                        <source
                            srcset="/app-guide/screenshot/android/Screenshot_20261003_151921.webp"
                            type="image/webp"
                        />
                        <img
                            src="/app-guide/screenshot/android/Screenshot_20261003_151921.png"
                            alt="제이드아이 홈 - 지금 할 수 있는 것, 오늘의 활동"
                            class="phone-screenshot"
                            width="1080"
                            height="2340"
                        />
                    </picture>
                </div>
            </div>
        </div>
    </div>

</section>

<style>
    .hero {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 6rem 1.5rem 2rem;
        background: linear-gradient(135deg, #f0f7f3 0%, #e8f5ee 30%, #fafbfa 100%);
        position: relative;
        overflow: hidden;
    }

    .hero::before {
        content: '';
        position: absolute;
        top: -50%;
        right: -30%;
        width: 80%;
        height: 80%;
        background: radial-gradient(circle, rgba(30, 92, 58, 0.06) 0%, transparent 70%);
        pointer-events: none;
    }

    .hero-inner {
        max-width: 72rem;
        margin: 0 auto;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 3rem;
        opacity: 0;
        transform: translateY(20px);
        transition: all 0.8s cubic-bezier(0.16, 1, 0.3, 1);
    }

    .hero-inner.visible {
        opacity: 1;
        transform: translateY(0);
    }

    /* Text */
    .hero-text {
        text-align: center;
        max-width: 36rem;
    }

    .hero-title {
        font-size: clamp(2.2rem, 5vw, 3.5rem);
        font-weight: 700;
        line-height: 1.25;
        letter-spacing: -0.03em;
        color: var(--landing-text, #1A1A1A);
        margin: 0 0 1.5rem;
    }

    .hero-subtitle {
        font-size: 1.1rem;
        color: var(--landing-text-sub, #666666);
        line-height: 1.7;
        margin: 0 0 2rem;
    }

    .hero-store-badges {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 0.75rem;
        align-items: center;
        justify-content: center;
    }

    .hero-badge-link {
        display: inline-flex;
        align-items: center;
        transition: opacity 0.2s, transform 0.2s;
    }

    .hero-badge-link:hover {
        opacity: 0.9;
        transform: translateY(-2px);
    }

    .hero-badge {
        height: 3.25rem;
        object-fit: contain;
        display: block;
        filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.12));
    }

    .hero-secondary-row {
        display: flex;
        justify-content: center;
        margin-top: 0.5rem;
    }

    .hero-cta-secondary {
        display: inline-flex;
        align-items: center;
        gap: 0.3rem;
        padding: 0.6rem 1.4rem;
        color: var(--landing-text-sub, #666666);
        font-size: 0.95rem;
        font-weight: 500;
        text-decoration: none;
        transition: color 0.2s;
    }

    .hero-cta-secondary:hover {
        color: var(--landing-primary, #1E5C3A);
    }

    /* Phone Mockup */
    .hero-visual {
        flex-shrink: 0;
    }

    .phone-mockup {
        width: 240px;
        height: 480px;
        background: #1a1a1a;
        border-radius: 32px;
        padding: 12px;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05);
    }

    .phone-screen {
        width: 100%;
        height: 100%;
        background: #f0f7f3;
        border-radius: 22px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .phone-screenshot {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
    }

    /* Responsive */
    @media (min-width: 768px) {
        .hero {
            padding: 6rem 2.5rem 2rem;
        }

        .hero-inner {
            flex-direction: row;
            align-items: center;
            gap: 4rem;
        }

        .hero-text {
            text-align: left;
            flex: 1;
        }

        .hero-store-badges {
            justify-content: flex-start;
        }

        .hero-secondary-row {
            justify-content: flex-start;
        }

        .phone-mockup {
            width: 280px;
            height: 560px;
        }
    }

    @media (min-width: 1024px) {
        .hero {
            padding: 6rem 3rem 2rem;
        }

        .phone-mockup {
            width: 300px;
            height: 600px;
        }
    }
</style>
